export default "__VITE_ASSET__BsPneEku__"